import React, { useEffect, useRef, useState } from "react";
import FindDieLocation from "./FindDieLocation";

declare global {
  interface Window {
    cv: any;
    cvReady?: boolean;
  }
}

export default function TestPage() {
  const [isCvReady, setIsCvReady] = useState(false);
  const [isPatternReady, setIsPatternReady] = useState(false);
  const [dieRects, setDieRects] = useState<
    Array<[string, [number, number, number, number]]>
  >([]);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const locatorRef = useRef<FindDieLocation | null>(null);
  if (!locatorRef.current) locatorRef.current = new FindDieLocation();

  // OpenCV.js 로딩 확인
  useEffect(() => {
    const tick = () => {
      if (window.cv && window.cv.imread) {
        if (!window.cvReady) {
          window.cvReady = true;
          setIsCvReady(true);
        }
      } else {
        setTimeout(tick, 200);
      }
    };
    tick();
  }, []);

  // 샘플 여러 장으로 패턴 학습
  const handleSampleImages = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!isCvReady) return;
    if (!e.target.files?.length) return;

    const cv = window.cv;
    const files = Array.from(e.target.files);
    const sampleMats: any[] = [];

    let loaded = 0;
    files.forEach((file) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d")!;
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        const mat = cv.imread(canvas);
        sampleMats.push(mat);

        loaded++;
        if (loaded === files.length) {
          locatorRef.current!.MakeDieMaskPattern(
            sampleMats,
            60,
            20,
            0.95,
            0.005
          );
          setIsPatternReady(true);
          console.log("마스크 패턴 학습 완료 ✅");
          // 메모리 정리
          sampleMats.forEach((m) => m.delete());
        }
      };
      img.src = URL.createObjectURL(file);
    });
  };

  // 새 이미지에서 다이 검출
  const handleTestImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!isCvReady || !isPatternReady) {
      alert("먼저 샘플 이미지로 마스크 패턴을 학습하세요!");
      return;
    }
    if (!e.target.files?.length) return;

    const file = e.target.files[0];
    const img = new Image();
    img.onload = () => {
      const canvas = canvasRef.current!;
      const ctx = canvas.getContext("2d")!;
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      const cv = window.cv;
      const src = cv.imread(canvas);

      const locator = locatorRef.current!;
      const rects = locator.GetDieRects(src);
      setDieRects(rects);

      // 캔버스에 사각형 그리기
      ctx.lineWidth = 2;
      ctx.strokeStyle = "lime";
      rects.forEach(([name, [x, y, w, h]]) => {
        ctx.strokeRect(x, y, w, h);
      });

      src.delete();
    };
    img.src = URL.createObjectURL(file);
  };

  return (
    <div style={{ display: "grid", gap: 12 }}>
      <h2>샘플 이미지로 마스크 패턴 학습</h2>
      <input type="file" multiple onChange={handleSampleImages} />
      {isPatternReady && (
        <div>패턴 학습 완료 ✅ 이제 테스트 이미지를 업로드하세요</div>
      )}

      <h2>테스트 이미지 업로드</h2>
      <input type="file" onChange={handleTestImage} />

      <canvas
        ref={canvasRef}
        style={{ border: "1px solid #333", maxWidth: "100%" }}
      />

      {dieRects.length > 0 && (
        <div>
          <h3>검출된 다이 Rects</h3>
          <ul>
            {dieRects.map(([name, rect], idx) => (
              <li key={idx}>
                {name}: {JSON.stringify(rect)}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
